export const SetDate = (date) => {
  let date_data = new Date(date);
  let year = date_data.getFullYear();
  let month = date_data.getMonth() + 1;
  let day = date_data.getDate();
  let splitStr = '.';
  return year+splitStr+month+splitStr+day;
}
